import { render, staticRenderFns } from "./VenueNote.vue?vue&type=template&id=64c4ff56&scoped=true&"
import script from "./VenueNote.vue?vue&type=script&lang=js&"
export * from "./VenueNote.vue?vue&type=script&lang=js&"
import style0 from "./VenueNote.vue?vue&type=style&index=0&id=64c4ff56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c4ff56",
  null
  
)

export default component.exports